import { create } from "zustand";
import { DomainContextProps } from "./storeTypes/domain.storeTypes";
import { UserStoresTypes } from "./storeTypes/user.storeTypes";
import {
  ExamResultDetailsTypes,
  QuestionResponse,
} from "../types/onlineExam.interface";

import { SubmissionStatusEnum } from "../environment";


const useUserStore = create<UserStoresTypes>((set) => ({
  userdetail: null,
  fullscreenCountDown: 5,
  showWarningModalForFulScreen: false,
  setShowWarningModalForFullscreen: (data: boolean) =>
    set(() => ({ showWarningModalForFulScreen: data })),
  setShowFullScreenCountDown: (data: number) =>
    set(() => ({ fullscreenCountDown: data })),
  windowFocused: false,
  setWindowFocused: (data: boolean) => set(() => ({ windowFocused: data })),
  setuserdetail: (data: any) => set(() => ({ userdetail: data })),
  islogin: false,
  setislogin: (data: boolean) => set(() => ({ islogin: data })),
  isAdmin: false,
  setisAdmin: (data: boolean) => set(() => ({ isAdmin: data })),
  setToken: (data: string) => set(() => ({ token: data })),
  token: undefined,
  loading: false,
  setLoading: (data: boolean) => set(() => ({ loading: data })),
  fullscreenmode: true,

  setFullScreenMode: (data: boolean) => set(() => ({ fullscreenmode: true })),
  setExam: (data: any) => set(() => ({ exam: data })),
  exam: {},
  setOfflineExamLineInformation: (data: any) =>
    set(() => ({ offlineExamInformation: data })),
  offlineExamInformation: undefined,
  setResultUploadedForOfflineCentre: (data: Array<any>) =>
    set(() => ({ isResultIsUploaded: data })),
  isResultIsUploaded: [],
  setIsResultUploadedUploadedForOfflineCentre: (data: boolean) =>
    set(() => ({ isResultUploadedForOfflineCentre: data })),
  isResultUploadedForOfflineCentre: false,
  endTimeOfExams: new Date().getTime(),
  setEndTimeOfExams: (data: number) => set(() => ({ endTimeOfExams: data })),
  setisTestCentreAdmin: (data: boolean) =>
    set(() => ({ isTestCentreAdmin: data })),
  isTestCentreAdmin: false,
  setIsQuestionSynced: (data: any) => set(() => ({ isQuestionSynced: data })),
  isQuestionSynced: false,
  setTests: (data: Array<any>) => set(() => ({ tests: data })),
  tests: [],
  isVisible: false,
  setIsVisible: (data: any) => set(() => ({ isVisible: data })),
  setExamStarted: (data: boolean) => set(() => ({ examStarted: data })),
  examStarted: false,
  examQuestionDetails: null,
  setExamQuestionDetails: (data: any) =>
    set(() => ({ examQuestionDetails: data })),
  setStartExamMessage: (data: string) =>
    set(() => ({ startExamMessage: data })),
  startExamMessage: "",
  // handleFullscreenChange,
  selectedExamGroup: null,
  setSelectedExamGroup: (data: any) => set(() => ({ selectedExamGroup: data })),
  setExamResultDetails: (data: ExamResultDetailsTypes | null) =>
    set(() => ({ examResultDetails: data })),
  examResultDetails: null,
  resultOfExamPapers: null,
  setResultOfExamPapers: (data: any) =>
    set(() => ({ resultOfExamPapers: data })),
  closeMyExam: false,
  setCloseMyExam: (data: boolean) => set(() => ({ closeMyExam: data })),
  submissionStateType: SubmissionStatusEnum.NOT_SUBMITTED,
  setSubmissionStateType: (data: SubmissionStatusEnum) =>
    set(() => ({ submissionStateType: data })),
  resumeDuration: 0,
  setResumeDuration: (data: number) => set(() => ({ resumeDuration: data })),
}));

export default useUserStore;
